module.exports = __webpack_public_path__ + "img/46.74b05a3.jpg";